import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';

const moment = require('moment')
const localizer = momentLocalizer(moment)

const statusClass = (event: any) => {
  let classStatus = ''

  switch (event.status) {
    // ALL = 0, // not used
    // PENDENT = 1,
    // IN_PROGRESS = 2,
    // DONE = 3,
    // ERROR = 4, // not used
    // OVERDUE = 5,
    // WAIT = 6 // not used
    case 1:
      classStatus = 'pendent'
      break;
    case 2:
      classStatus = 'in-progress'
      break;
    case 3:
      classStatus = 'done'
      break;
    case 5:
      classStatus = 'is-overdue'
      break;
  
    default:
      break;
  }

  return { className: classStatus }
}

const MyCalendar = (props: any) => (
  <div style={{height: 900}}>
    <Calendar
      selectable
      localizer={localizer}
      events={props.events}
      timeslots={2}
      defaultDate={new Date()}
      onSelectSlot={(slotInfo: any) => props.selectSlotHandler(slotInfo)}
      onSelectEvent={(event: any) => props.selectEventHandler(event)}
      startAccessor="start"
      endAccessor="end"
      eventPropGetter={statusClass}
    />
  </div>
)

export default MyCalendar;